export default "__VITE_ASSET__BTrcMhcU__"